/**
 * @fileoverview gRPC-Web generated client stub for pbs
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.19.6
// source: user.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var common_pb = require('./common_pb.js')

var role_pb = require('./role_pb.js')

var school_pb = require('./school_pb.js')
const proto = {};
proto.pbs = require('./user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.UserServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.UserServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.LoginUser,
 *   !proto.pbs.User>}
 */
const methodDescriptor_UserService_Login = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Login',
  grpc.web.MethodType.UNARY,
  proto.pbs.LoginUser,
  proto.pbs.User,
  /**
   * @param {!proto.pbs.LoginUser} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.User.deserializeBinary
);


/**
 * @param {!proto.pbs.LoginUser} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.login =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login,
      callback);
};


/**
 * @param {!proto.pbs.LoginUser} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.User>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.login =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Login',
      request,
      metadata || {},
      methodDescriptor_UserService_Login);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.LoginUser,
 *   !proto.pbs.User>}
 */
const methodDescriptor_UserService_AdminLogin = new grpc.web.MethodDescriptor(
  '/pbs.UserService/AdminLogin',
  grpc.web.MethodType.UNARY,
  proto.pbs.LoginUser,
  proto.pbs.User,
  /**
   * @param {!proto.pbs.LoginUser} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.User.deserializeBinary
);


/**
 * @param {!proto.pbs.LoginUser} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.adminLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/AdminLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_AdminLogin,
      callback);
};


/**
 * @param {!proto.pbs.LoginUser} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.User>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.adminLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/AdminLogin',
      request,
      metadata || {},
      methodDescriptor_UserService_AdminLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserLogoutReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Logout = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Logout',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserLogoutReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.UserLogoutReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.UserLogoutReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.logout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout,
      callback);
};


/**
 * @param {!proto.pbs.UserLogoutReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.logout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Logout',
      request,
      metadata || {},
      methodDescriptor_UserService_Logout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.Empty,
 *   !proto.pbs.CodeResp>}
 */
const methodDescriptor_UserService_GetCode = new grpc.web.MethodDescriptor(
  '/pbs.UserService/GetCode',
  grpc.web.MethodType.UNARY,
  common_pb.Empty,
  proto.pbs.CodeResp,
  /**
   * @param {!proto.pbs.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.CodeResp.deserializeBinary
);


/**
 * @param {!proto.pbs.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.CodeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.CodeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.getCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/GetCode',
      request,
      metadata || {},
      methodDescriptor_UserService_GetCode,
      callback);
};


/**
 * @param {!proto.pbs.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.CodeResp>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.getCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/GetCode',
      request,
      metadata || {},
      methodDescriptor_UserService_GetCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.CreateUserReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Create = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Create',
  grpc.web.MethodType.UNARY,
  proto.pbs.CreateUserReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.CreateUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.CreateUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Create',
      request,
      metadata || {},
      methodDescriptor_UserService_Create,
      callback);
};


/**
 * @param {!proto.pbs.CreateUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Create',
      request,
      metadata || {},
      methodDescriptor_UserService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UpdateUserReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Update = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Update',
  grpc.web.MethodType.UNARY,
  proto.pbs.UpdateUserReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.UpdateUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.UpdateUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Update',
      request,
      metadata || {},
      methodDescriptor_UserService_Update,
      callback);
};


/**
 * @param {!proto.pbs.UpdateUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Update',
      request,
      metadata || {},
      methodDescriptor_UserService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserDeleteReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Delete = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Delete',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserDeleteReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.UserDeleteReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.UserDeleteReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Delete',
      request,
      metadata || {},
      methodDescriptor_UserService_Delete,
      callback);
};


/**
 * @param {!proto.pbs.UserDeleteReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Delete',
      request,
      metadata || {},
      methodDescriptor_UserService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.ChangePasswordReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_ChangePassword = new grpc.web.MethodDescriptor(
  '/pbs.UserService/ChangePassword',
  grpc.web.MethodType.UNARY,
  proto.pbs.ChangePasswordReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.ChangePasswordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.ChangePasswordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.changePassword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword,
      callback);
};


/**
 * @param {!proto.pbs.ChangePasswordReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.changePassword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/ChangePassword',
      request,
      metadata || {},
      methodDescriptor_UserService_ChangePassword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.RegisterReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Register = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Register',
  grpc.web.MethodType.UNARY,
  proto.pbs.RegisterReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.RegisterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.RegisterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.register =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Register',
      request,
      metadata || {},
      methodDescriptor_UserService_Register,
      callback);
};


/**
 * @param {!proto.pbs.RegisterReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.register =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Register',
      request,
      metadata || {},
      methodDescriptor_UserService_Register);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.SendCodeReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_SendCode = new grpc.web.MethodDescriptor(
  '/pbs.UserService/SendCode',
  grpc.web.MethodType.UNARY,
  proto.pbs.SendCodeReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.SendCodeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.SendCodeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.sendCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/SendCode',
      request,
      metadata || {},
      methodDescriptor_UserService_SendCode,
      callback);
};


/**
 * @param {!proto.pbs.SendCodeReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.sendCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/SendCode',
      request,
      metadata || {},
      methodDescriptor_UserService_SendCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserLoginSummaryReq,
 *   !proto.pbs.UserLoginSummaryResp>}
 */
const methodDescriptor_UserService_GetLoginSummary = new grpc.web.MethodDescriptor(
  '/pbs.UserService/GetLoginSummary',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserLoginSummaryReq,
  proto.pbs.UserLoginSummaryResp,
  /**
   * @param {!proto.pbs.UserLoginSummaryReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.UserLoginSummaryResp.deserializeBinary
);


/**
 * @param {!proto.pbs.UserLoginSummaryReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.UserLoginSummaryResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.UserLoginSummaryResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.getLoginSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/GetLoginSummary',
      request,
      metadata || {},
      methodDescriptor_UserService_GetLoginSummary,
      callback);
};


/**
 * @param {!proto.pbs.UserLoginSummaryReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.UserLoginSummaryResp>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.getLoginSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/GetLoginSummary',
      request,
      metadata || {},
      methodDescriptor_UserService_GetLoginSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserListReq,
 *   !proto.pbs.UserListResp>}
 */
const methodDescriptor_UserService_GetList = new grpc.web.MethodDescriptor(
  '/pbs.UserService/GetList',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserListReq,
  proto.pbs.UserListResp,
  /**
   * @param {!proto.pbs.UserListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.UserListResp.deserializeBinary
);


/**
 * @param {!proto.pbs.UserListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.UserListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.UserListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.getList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/GetList',
      request,
      metadata || {},
      methodDescriptor_UserService_GetList,
      callback);
};


/**
 * @param {!proto.pbs.UserListReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.UserListResp>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.getList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/GetList',
      request,
      metadata || {},
      methodDescriptor_UserService_GetList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.Empty,
 *   !proto.pbs.User>}
 */
const methodDescriptor_UserService_GetMyAccontInfo = new grpc.web.MethodDescriptor(
  '/pbs.UserService/GetMyAccontInfo',
  grpc.web.MethodType.UNARY,
  common_pb.Empty,
  proto.pbs.User,
  /**
   * @param {!proto.pbs.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.User.deserializeBinary
);


/**
 * @param {!proto.pbs.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.getMyAccontInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/GetMyAccontInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_GetMyAccontInfo,
      callback);
};


/**
 * @param {!proto.pbs.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.User>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.getMyAccontInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/GetMyAccontInfo',
      request,
      metadata || {},
      methodDescriptor_UserService_GetMyAccontInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserSwitchReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_BanToPost = new grpc.web.MethodDescriptor(
  '/pbs.UserService/BanToPost',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserSwitchReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.UserSwitchReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.UserSwitchReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.banToPost =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/BanToPost',
      request,
      metadata || {},
      methodDescriptor_UserService_BanToPost,
      callback);
};


/**
 * @param {!proto.pbs.UserSwitchReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.banToPost =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/BanToPost',
      request,
      metadata || {},
      methodDescriptor_UserService_BanToPost);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.UserSwitchReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_Ban = new grpc.web.MethodDescriptor(
  '/pbs.UserService/Ban',
  grpc.web.MethodType.UNARY,
  proto.pbs.UserSwitchReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.UserSwitchReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.UserSwitchReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.ban =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/Ban',
      request,
      metadata || {},
      methodDescriptor_UserService_Ban,
      callback);
};


/**
 * @param {!proto.pbs.UserSwitchReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.ban =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/Ban',
      request,
      metadata || {},
      methodDescriptor_UserService_Ban);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.ClientConfigReq,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_UserService_ClientSysConfig = new grpc.web.MethodDescriptor(
  '/pbs.UserService/ClientSysConfig',
  grpc.web.MethodType.UNARY,
  proto.pbs.ClientConfigReq,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.ClientConfigReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.ClientConfigReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.UserServiceClient.prototype.clientSysConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.UserService/ClientSysConfig',
      request,
      metadata || {},
      methodDescriptor_UserService_ClientSysConfig,
      callback);
};


/**
 * @param {!proto.pbs.ClientConfigReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     Promise that resolves to the response
 */
proto.pbs.UserServicePromiseClient.prototype.clientSysConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.UserService/ClientSysConfig',
      request,
      metadata || {},
      methodDescriptor_UserService_ClientSysConfig);
};


module.exports = proto.pbs;




// WEBPACK FOOTER //
// ./src/pbs/user_grpc_web_pb.js